var map = {
	"./1.png": 1591,
	"./2.png": 1592,
	"./3.png": 1593,
	"./4.png": 1594,
	"./5.png": 1595,
	"./6.png": 1596,
	"./7.png": 1597,
	"./8.png": 1598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1590;